const register = {
  loginCredentials: "Credenciales de acceso", // translated
  companyInformation: "Información de la empresa", // translated
  contactDetails: "Detalles de contacto", // translated
  businessName: "Nombre del Negocio", // translated
  businessAddress: "Dirección de Negocios", // translated
  registrationCode: "Código de registro", // translated
  websiteUrl: "URL del sitio web", // translated
  mobilePhone: "Teléfono móvil", // translated
  regionStateProvince: "Región/Estado/Provincia", // translated
  legalTitle: "Titulo legal", // translated
  city: "Ciudad", // translated
  postalCode: "Código Postal", // translated
  registrationSuccess: "Registración exitosa.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "Espere unos momentos y será redirigido a la página de inicio.", // translated
};

export default register;
